<div class="cal-header">
  <button
    type="button"
    class="cal-header__period"
    (click)="currentPeriodClicked()"
    [attr.aria-label]="periodButtonLabel"
    >
    {{ periodLabel }}
  </button>

  <div class="cal-header__nav">
    <button
      type="button"
      class="cal-header__arrow cal-header__arrow--prev"
      [disabled]="!previousEnabled()"
      (click)="previousClicked()"
      [attr.aria-label]="prevButtonLabel"
      [matTooltip]="prevButtonLabel"
      matTooltipClass="white-tooltip"
      >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 9L12.381 15L20 9" stroke="#060B1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>

    <button
      type="button"
      data-testid="calendar-next" class="cal-header__arrow cal-header__arrow--next"
      [disabled]="!nextEnabled()"
      (click)="nextClicked()"
      [attr.aria-label]="nextButtonLabel"
      [matTooltip]="nextButtonLabel"
      matTooltipClass="white-tooltip"
      >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 9L12.381 15L20 9" stroke="#060B1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
  </div>
</div>
